(function(){
  'use strict';
  var busy=false;
  function spanish(){
    var match=document.cookie.match(/(?:^|;\s*)sn-multiling=([^;]+)/);
    if(match)return decodeURIComponent(match[1])==='lang2';
    return !!(window._bilingualTheme&&window._bilingualTheme.settings&&String(window._bilingualTheme.settings.primary_language)==='2');
  }
  function copy(en,es){return spanish()?es:en;}
  function toast(message){
    var el=document.querySelector('.ld-cart-toast');
    if(!el){el=document.createElement('div');el.className='ld-cart-toast';el.setAttribute('role','status');el.setAttribute('aria-live','polite');document.body.appendChild(el);}
    el.textContent=message;el.classList.add('is-visible');clearTimeout(toast.timer);toast.timer=setTimeout(function(){el.classList.remove('is-visible');},3200);
  }
  function counters(count){
    document.querySelectorAll('.cart-item-total,[data-cart-count],.cart-count,.cart__count,#cart-count').forEach(function(el){el.textContent=count;el.removeAttribute('hidden');});
  }
  function confirmCart(){
    if(busy)return;busy=true;
    setTimeout(function(){
      fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
        .then(function(r){if(!r.ok)throw new Error('Cart request failed');return r.json();})
        .then(function(cart){counters(cart.item_count);toast(copy('Added to your cart. Cart: '+cart.item_count+' item(s).','Añadido al carrito. Carrito: '+cart.item_count+' producto(s).'));window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'ld_cart_confirmed',cart_item_count:cart.item_count});})
        .catch(function(){toast(copy('Please check your cart to confirm the product was added.','Revisa el carrito para confirmar que el producto se añadió.'));})
        .finally(function(){busy=false;});
    },500);
  }
  function deliveryBlock(){
    var nodes=document.querySelectorAll('h1,h2,h3,h4,label,legend,div,span,p');
    for(var i=0;i<nodes.length;i+=1){if(/Schedule Delivery Date|Delivery Date|Fecha de entrega/i.test((nodes[i].textContent||'').trim()))return nodes[i].closest('fieldset,section,[class*="delivery"],[class*="kaspud"],div')||nodes[i];}
    return null;
  }
  function guidance(){
    if(window.location.pathname.indexOf('/cart')!==0||document.querySelector('.ld-checkout-guidance'))return;
    var button=document.querySelector('button[name="checkout"],input[name="checkout"]');if(!button||!button.parentNode)return;
    var note=document.createElement('div');note.className='ld-checkout-guidance';note.setAttribute('role','note');note.textContent=copy('Next step: choose your delivery date or “Deliver Anytime”, then continue to secure checkout.','Siguiente paso: elige la fecha de entrega o “Entregar en cualquier momento” y continúa al pago seguro.');button.parentNode.insertBefore(note,button);
  }
  function refreshGuidance(){var note=document.querySelector('.ld-checkout-guidance');if(note)note.textContent=copy('Next step: choose your delivery date or “Deliver Anytime”, then continue to secure checkout.','Siguiente paso: elige la fecha de entrega o “Entregar en cualquier momento” y continúa al pago seguro.');}
  function focusDelivery(){
    setTimeout(function(){var block=deliveryBlock();if(!block)return;block.classList.add('ld-delivery-highlight');block.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(function(){block.classList.remove('ld-delivery-highlight');},2600);window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'ld_delivery_step_revealed'});},250);
  }
  document.addEventListener('submit',function(e){if(e.target&&e.target.matches('form[action*="/cart/add"]'))confirmCart();},true);
  document.addEventListener('cart:updated',confirmCart);
  document.addEventListener('product:added',function(){
    confirmCart();
    if(window.location.pathname.indexOf('/cart')===0){setTimeout(function(){window.location.reload();},1100);}
  });
  document.addEventListener('click',function(e){var checkout=e.target.closest&&e.target.closest('button[name="checkout"],input[name="checkout"]');if(checkout&&window.location.pathname.indexOf('/cart')===0)focusDelivery();if(e.target.closest&&e.target.closest('.btn-lang1,.btn-lang2'))setTimeout(refreshGuidance,0);},true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',guidance);else guidance();
}());
/* La despensa: bilingual support for app-rendered filters and legacy pipe labels. */
(function(){
  'use strict';
  var originals=new WeakMap();
  var scheduled=false;
  var filterSpanish={
    'Filters':'Filtros',
    'EVOO TYPE':'TIPO DE AOVE',
    'Gift Idea':'Idea para regalar',
    'Unfiltered':'Sin filtrar',
    'OLIVES':'ACEITUNAS',
    'PICKLES':'ENCURTIDOS',
    'OLIVE VARIETY':'VARIEDAD DE ACEITUNA',
    'BRAND':'MARCA',
    'COLLECTION':'COLECCIÓN',
    'SORT BY: Featured':'ORDENAR POR: DESTACADOS',
    'SORT BY: Best selling':'ORDENAR POR: MÁS VENDIDOS',
    'SORT BY: Alphabetically, A-Z':'ORDENAR POR: ALFABÉTICAMENTE, A-Z',
    'SORT BY: Alphabetically, Z-A':'ORDENAR POR: ALFABÉTICAMENTE, Z-A',
    'SORT BY: Price, low to high':'ORDENAR POR: PRECIO, MENOR A MAYOR',
    'SORT BY: Price, high to low':'ORDENAR POR: PRECIO, MAYOR A MENOR',
    'SORT BY: Date, new to old':'ORDENAR POR: MÁS RECIENTES',
    'SORT BY: Date, old to new':'ORDENAR POR: MÁS ANTIGUOS',
    'SORT BY':'ORDENAR POR'
  };

  function isSpanish(){
    var match=document.cookie.match(/(?:^|;\s*)sn-multiling=([^;]+)/);
    return match&&decodeURIComponent(match[1])==='lang2';
  }

  function translateTextNode(node){
    var raw=originals.get(node)||node.nodeValue;
    var trimmed=raw.trim();
    if(raw.indexOf('|')===-1){
      var translated=filterSpanish[trimmed];
      if(!translated)return;
      if(!originals.has(node))originals.set(node,raw);
      var singleResult=isSpanish()?raw.replace(trimmed,translated):raw;
      if(node.nodeValue!==singleResult)node.nodeValue=singleResult;
      return;
    }
    if(!originals.has(node))originals.set(node,raw);
    var countMatch=raw.match(/\s*(\(\d+\))\s*$/);
    var count=countMatch?' '+countMatch[1]:'';
    var withoutCount=countMatch?raw.slice(0,countMatch.index):raw;
    var separator=withoutCount.indexOf('|');
    if(separator===-1)return;
    var english=withoutCount.slice(0,separator).trim();
    var spanishText=withoutCount.slice(separator+1).trim();
    var bilingualResult=(isSpanish()?spanishText:english)+count;
    if(node.nodeValue!==bilingualResult)node.nodeValue=bilingualResult;
  }

  function translateRoot(root){
    if(!root)return;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null,false);
    var nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(translateTextNode);
  }

  function refresh(){
    scheduled=false;
    translateRoot(document.getElementById('cloud_search_filters_root'));
    translateRoot(document.getElementById('cloud_search_filters_sidebar'));
    document.querySelectorAll('[class*="cloud-search"],[class*="cloud_search"],[id*="cloud-search"],[id*="cloud_search"]').forEach(translateRoot);
    document.querySelectorAll('a,button').forEach(function(el){
      if(el.children.length===0&&/\|/.test(el.textContent))translateRoot(el);
    });
  }

  function schedule(){
    if(scheduled)return;
    scheduled=true;
    window.requestAnimationFrame(refresh);
  }

  document.addEventListener('DOMContentLoaded',function(){
    schedule();
    var observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true,characterData:true});
    document.querySelectorAll('.lang-select [data-lang]').forEach(function(control){
      control.addEventListener('click',function(){window.setTimeout(refresh,0);});
    });
  });
}());
